import { useState } from 'react';
import { withQueryparams } from '@/main/components/core/queryParams/queryparams';
import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout';
import { getTranslateByKey } from '@/main/services/utils';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';
import FiltersEmailTemplatesWrapper from './filtersEmailTemplates/filtersEmailTemplates';
import { SearchgridTemplateRequest } from '@/main/models/request/templateEmailNotificationCompanyRequest';
import GridSearchEmailTemplate, {
  IGridData,
  INITIAL_GRID_STATE
} from './gridEmailTemplate/gridEmailTemplate';
import { templateEmailNotificationCompanyApi } from '@/main/api';

function SearchEmailTemplatesScreen() {
  const titlePage = `${getTranslateByKey(
    'information.registration'
  )} > ${getTranslateByKey('screen.EmailTemplates')}`;

  const [gridData, setGridData] = useState<IGridData>(INITIAL_GRID_STATE);
  const [formFilters, setFormFilters] =
    useState<SearchgridTemplateRequest | null>(null);

  function onResetSearch() {
    setGridData(INITIAL_GRID_STATE);
    setFormFilters(null);
  }

  async function getDataEmailTemplate(
    filters:
      | SearchgridTemplateRequest
      | Partial<SearchgridTemplateRequest> = {},
    isResetSearch: boolean = true
  ) {
    const request: SearchgridTemplateRequest = {
      ...(isResetSearch ? {} : formFilters),
      ...(filters as SearchgridTemplateRequest),
      pageIndex: PaginationEnum.PageIndexIntial,
      pageSize: PaginationEnum.PageSize30
    };

    setGridData({
      isLoading: true,
      totalItems: 0,
      data: []
    });

    setFormFilters(request);

    setGridData(crr => ({ ...crr, isLoading: true }));
    templateEmailNotificationCompanyApi
      .getSearchGridTemplate(request)
      .then(response => {
        let resultData: any[] = [];
        let resultTotalItems: number = 0;
        if (response.data) {
          resultData = response.data.results;
          resultTotalItems = response.data.totalNumberOfRecords;
        }
        setGridData({
          isLoading: false,
          totalItems: resultTotalItems,
          data: resultData
        });
      });
  }

  return (
    <ContainerScreen title={titlePage}>
      <FiltersEmailTemplatesWrapper
        onResetSearch={onResetSearch}
        getDataEmailTemplate={getDataEmailTemplate}
      />

      <GridSearchEmailTemplate
        gridData={gridData}
        formFilters={formFilters}
        setGridData={setGridData}
      />
    </ContainerScreen>
  );
}

export default withQueryparams(SearchEmailTemplatesScreen);
